module.exports = __webpack_public_path__ + "static/media/在线象棋.f48c9033.png";